import algoliasearch from 'algoliasearch';
import { ProductEntity } from 'src/modules/products';

import { trim } from 'lodash';

// const NUM_TOP_SEARCHES = 5;

const createInCondition = (algoliaFacetName, values) => {
  return values.map((v) => `${algoliaFacetName}:${v}`);
};

export const algoliaSearch = async (term, outputChannel, filters?, pagination?) => {
  const searchTerm = trim(term);

  const client = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
    process.env.NEXT_PUBLIC_ALGOLIA_WRITE_KEY
  );
  const index = client.initIndex(`${process.env.NEXT_PUBLIC_ALGOLIA_PREFIX}_products`);

  const attributesForFaceting = ['channels'];

  const facetFilters = [];

  if (filters) {
    const { productCategoryIds, locationTypeIds, designerIds } = filters;

    if (productCategoryIds && productCategoryIds.length) {
      facetFilters.push(createInCondition('product_categories.id', productCategoryIds));
      attributesForFaceting.push('product_categories.id');
    }

    if (locationTypeIds && locationTypeIds.length) {
      facetFilters.push(createInCondition('location_types.id', locationTypeIds));
      attributesForFaceting.push('location_types.id');
    }

    if (designerIds && designerIds.length) {
      facetFilters.push(createInCondition('product_series.designer', designerIds));
      attributesForFaceting.push('location_types.id');
    }
  }

  index.setSettings({
    attributesForFaceting,
  });
  facetFilters.push(`channels:${outputChannel}`);

  try {
    const searchResults = await index.search<ProductEntity>(searchTerm, {
      facetFilters,
      ...pagination,
    });

    // algolia ids are pim ids
    // const productPimIds = searchResults.hits.map((sr) => sr.id);

    // const results = [];

    // if (productPimIds.length) {
    //   results = await strapi.query('product').find(
    //     {
    //       pim_id_in: productPimIds,
    //     },
    //     [
    //       'product_categories',
    //       'assets',
    //       'product_subcategories',
    //       'location_types',
    //       'dynamic_content',
    //       {
    //         path: 'product_series',
    //         select: '+id +name_en +name_de +designer',
    //         populate: { path: 'designer', select: 'name' },
    //       },
    //     ]
    //   );

    //   results.forEach((result) => {
    //     const clippedImage = sortBy(
    //       result.assets.filter((a) => a.subtype === 'picture.pdp-cutout.'),
    //       ['sorting'],
    //       ['asc']
    //     )[0];

    //     if (clippedImage) {
    //       result.assets = [clippedImage];
    //     }
    //   });
    // }

    const count = searchResults.nbHits || 0;

    return { count, results: searchResults.hits };
  } catch (e) {
    console.error(e);
    return [];
  }
};
